export default "__VITE_PUBLIC_ASSET__710e1e71__"